class EventBus {
  events = {};
  $on(type, callback, caller) {
    if(typeof callback !== 'function') {
      throw new Error('callback must be a Function');
    }
    this.events[type] = this.events[type] || [];
    const listener = { callback, caller };
    this.events[type].push(listener);
    return () => {
      this.events[type] = this.events[type].filter(item => item !== listener);
    };
  }
  $emit(type, payload) {
    if (!this.events[type]) return
    this.events[type].forEach(({ callback, caller }) => {
      callback.call(caller, payload);
    });
  }
  $off(type) {
    this.events[type] = [];
    return this;
  }
  $has(type) {
    return !!this.events[type] && this.events[type].length > 0;
  }
}

export default new EventBus();
